
import React from 'react';
import { API_CONFIG } from '@/config/envConfig';

const LoadingScreen = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-purple-50 flex items-center justify-center font-mark">
      <div className="text-center">
        <div className="mb-8">
          <img 
            src="/lovable-uploads/6823d161-b5be-421b-863a-12eaf2ea796e.png" 
            alt="HBox Logo" 
            className="h-16 w-auto mx-auto mb-6"
          />
        </div>
        
        <div className="flex items-center justify-center space-x-2 mb-6">
          <div className="w-3 h-3 bg-hbox-purple rounded-full animate-bounce"></div>
          <div className="w-3 h-3 bg-hbox-pink rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
          <div className="w-3 h-3 bg-hbox-teal rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
        </div>
        
        <h2 className="text-xl font-semibold text-gray-700 mb-2">Loading HBox Platform</h2>
        <p className="text-gray-500 text-sm">
          Connecting to <span className="font-medium text-hbox-purple">{API_CONFIG.ORIGIN_URL.replace(/^https?:\/\//, '')}</span>
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;